const CHECKOUT_FLAG_KEY = 'checkout'
const CHECKOUT_PAYMENT_ID_KEY = 'checkoutPaymentId'
const CHECKOUT_RESERVATION_ID_KEY = 'checkoutReservationId'
const STRIPE_RETURN_QUERY_KEYS = [
  'payment_intent',
  'payment_intent_client_secret',
  'redirect_status'
]

export const buildPaidCheckoutSearch = ({
  currentSearch = '',
  paymentId,
  reservationId
}) => {
  const params = new URLSearchParams(currentSearch)

  STRIPE_RETURN_QUERY_KEYS.forEach((key) => params.delete(key))

  if (paymentId && reservationId) {
    params.set(CHECKOUT_FLAG_KEY, '1')
    params.set(CHECKOUT_PAYMENT_ID_KEY, paymentId)
    params.set(CHECKOUT_RESERVATION_ID_KEY, reservationId)
  } else {
    params.delete(CHECKOUT_FLAG_KEY)
    params.delete(CHECKOUT_PAYMENT_ID_KEY)
    params.delete(CHECKOUT_RESERVATION_ID_KEY)
  }

  const nextSearch = params.toString()
  return nextSearch ? `?${nextSearch}` : ''
}

export const buildPaidCheckoutReturnUrl = ({
  origin,
  pathname,
  currentSearch = '',
  paymentId,
  reservationId
}) => {
  const effectiveOrigin = origin ||
    process.env.REACT_APP_CLIENT_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '')
  const effectivePathname = pathname ||
    (typeof window !== 'undefined' ? window.location.pathname : '/')
  const search = buildPaidCheckoutSearch({
    currentSearch,
    paymentId,
    reservationId
  })

  return `${effectiveOrigin}${effectivePathname}${search}`
}

export const readPaidCheckoutContextFromSearch = (search = '') => {
  const params = new URLSearchParams(search)
  const paymentId = params.get(CHECKOUT_PAYMENT_ID_KEY)
  const reservationId = params.get(CHECKOUT_RESERVATION_ID_KEY)

  if (params.get(CHECKOUT_FLAG_KEY) !== '1' || !paymentId || !reservationId) {
    return null
  }

  return {
    paymentId,
    reservationId,
    paymentIntentId: params.get('payment_intent') || null,
    redirectStatus: params.get('redirect_status') || null
  }
}

export const clearPaidCheckoutSearch = (search = '') => {
  const params = new URLSearchParams(search)

  ;[
    CHECKOUT_FLAG_KEY,
    CHECKOUT_PAYMENT_ID_KEY,
    CHECKOUT_RESERVATION_ID_KEY,
    ...STRIPE_RETURN_QUERY_KEYS
  ].forEach((key) => params.delete(key))

  const nextSearch = params.toString()
  return nextSearch ? `?${nextSearch}` : ''
}
